import { useQuery } from "@tanstack/react-query";
import { DocumentLinkService } from "../../../../services/document/document-link.service";
import { useMemo } from "react";

export const useDocumentLinkById = (id: string | undefined | number) => {
  const docId = id?.toString();

  const { data, ...rest } = useQuery({
    queryKey: ["document-link", docId],
    queryFn: () => DocumentLinkService.getDocumentLinkInfos(docId),
    enabled: !!id,
  });

  const docLinkCount = useMemo(() => (!data ? 0 : data.data.filter((e: any) => !e.isDeleted).length), [data]);

  return { data, docLinkCount, ...rest };
};
